import React, {Component} from 'react';
import ProvidersHeader from './ProvidersHeader.js';
import OtherProvidersTable from './OtherProvidersTable.js';
import CableRow from './CableRow.js';

class ProvidersTable extends Component
{
	constructor(props)
	{
		super(props)
		this.state =
		{
			hasListings:false,
			providers:[]
		}
		this.displayCableRow = this.displayCableRow.bind(this);
		this.sortData = this.sortData.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		// console.log('next',nextProps)
		let data = nextProps.data;
		let length = data.length;
		let allProviders = [];
		let currentProvArr = [];
		let currentProv = "";
		for (let i = 0; i < length; i++)
		{
			let current = data[i].operator;
			// let current = data[i].name;
			if (current !== currentProv && currentProv !== "")
			{
				allProviders.push(currentProvArr);
				currentProvArr = [];
			}
			currentProv = current;
			currentProvArr.push(data[i]);
		}

		if (currentProvArr.length > 0 )
		{
			allProviders.push(currentProvArr);
		}

		let order = this.checkOrder()



		this.setState(
			{
				hasListings:true,
				providers:allProviders,
				order:order
			}
		)
	}

	checkOrder()
	{
		let order = [];
		switch(this.props.channel)
		{		
			case "hmm":
				order = ["Mystery", "Channel", "Family"]; 
				break;
			case "hd":
				order = ["Family", "Channel","Mystery"];
				break;
			default:
				order = ["Channel", "Mystery", "Family"];
		}

		return order;
	}

	displayCableRow(mvpd, i)
	{
		let operator = mvpd[0].operator;
		// let name = mvpd[0].name;
		let rowClass = "row table-row";
		if (i%2) 
		{
			rowClass = rowClass += " table-row-grey"
		}
		let sortedMvpd = this.sortData(mvpd);
		return(<CableRow key={i} operator={operator} mvpd={sortedMvpd} rowClass={rowClass}/>)
		// return(<CableRow key={i} name={name} mvpd={sortedMvpd} rowClass={rowClass}/>)
	}
	

	sortData(mvpd)
	{
		let order = this.state.order;
		let length = mvpd.length;
		let sorted = [{},{},{}];
		for (let i = 0; i < length; i++)
		{
			let current = mvpd[i];
			let channel;
			if (current.channelName.indexOf(order[0]) > -1)
			{
				channel = 0;
			}
			else if (current.channelName.indexOf(order[1]) > -1)
			{
				channel = 1;
			}
			else if(current.channelName.indexOf(order[2]) > -1)
			{
				channel = 2;
			}


			if (current.channelName.indexOf("HD") > -1)
			{
				let existing;
				let duplicate;
				if (sorted[channel].HD)
				{
                    existing = sorted[channel].HD.channelNumber;
					duplicate = current.channelNumber;
                    if (existing.indexOf(duplicate) < 0)
                    {	
                        let multichannels = existing + "/" + duplicate;
                        current.channelNumber = multichannels;
						sorted[channel].HD = current;
					}
				}

				if (!sorted[channel].HD)
				{
					sorted[channel].HD = current;
				} 
			} else 
			{
				let existing;
				let duplicate;
				if (sorted[channel].SD)
				{
                    existing = sorted[channel].SD.channelNumber;
					duplicate = current.channelNumber;
                    if (existing.indexOf(duplicate) < 0)
                    {	
                        let multichannels = existing + "/" + duplicate;
                        current.channelNumber = multichannels;
						sorted[channel].SD = current;
					}
				}

				if (!sorted[channel].SD)
				{
					sorted[channel].SD = current;
				} 
			}
		}
		return sorted;
	}
	render()
	{
		if (this.state.hasListings && this.state.providers.length > 0)
			{
			return(<div className="container large-devices">
				<div className="table-border table">
					<ProvidersHeader channel={this.props.channel}/>
					{this.state.providers.map(this.displayCableRow)}
				</div>
				<OtherProvidersTable channel={this.props.channel} order={this.state.order}/>
				
			</div>
			)
		}
		else if (this.state.hasListings)
		{
			return(<div className="container large-devices">
				<OtherProvidersTable channel={this.props.channel} order={this.state.order}/>
				
			</div>
			)
		}
		return(<div className="large-devices"></div>)
	}
}

export default ProvidersTable;


// WEBPACK FOOTER //
// ./src/components/ProvidersTable.js